function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.17503 8.74005C8.47917 8.74005 7.91507 9.30415 7.91507 10C7.91507 10.6959 8.47917 11.26 9.17503 11.26L9.17503 8.74005ZM10.7659 10.8909C11.258 10.3989 11.258 9.60112 10.7659 9.10908L2.74763 1.09079C2.25559 0.598751 1.45783 0.598751 0.965793 1.09079C0.47375 1.58284 0.47375 2.38059 0.965793 2.87263L8.09316 10L0.965793 17.1274C0.473751 17.6194 0.473751 18.4172 0.965793 18.9092C1.45784 19.4012 2.25559 19.4012 2.74763 18.9092L10.7659 10.8909ZM9.17503 11.26L9.875 11.26L9.875 8.74005L9.17503 8.74005L9.17503 11.26Z",
  fill: "white"
});

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.34d7ed1f.svg";
export { ForwardRef as ReactComponent };